import axios from "axios";
import Vue from "vue";

// const testToken = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNhZWE4Mzk5NDkwMjM4Yjg4MmU3MGYwNjQxMGE4Yjg3MDk2YTQyNGM2ZmIxZWFkNmYyMjllMjljNWU3YjFiOWVmOTdjZDkxYWY1ODczMWY4In0.eyJhdWQiOiI0IiwianRpIjoiM2FlYTgzOTk0OTAyMzhiODgyZTcwZjA2NDEwYThiODcwOTZhNDI0YzZmYjFlYWQ2ZjIyOWUyOWM1ZTdiMWI5ZWY5N2NkOTFhZjU4NzMxZjgiLCJpYXQiOjE1OTU2NjQ2MTEsIm5iZiI6MTU5NTY2NDYxMSwiZXhwIjoxNjI3MjAwNjExLCJzdWIiOiIzNTkiLCJzY29wZXMiOltdLCJpc3MiOiJtZW1iZXIifQ.qVI3yXZmRRqJvQaU7oMT5Onh3fjXXWIl92nXSFx1LEQEUXBVUR9_qled7PYFPp9mP178DzpPCKOPeUCajwjuTfP65y9nlva1jSiWW9zoofTiZ-bgQmaqaTy5Z-VX8QRrVFeSgVqNr8Rz_gpovQNBnXB6oUI3qugkO_bqhVb5OVzur8gBXgEunbz97m2jmKbmGEJsbnWajMFWhaZmT7tAOkV_WFrEsFblKrSfHvWfwxqlrsHBFKmfAsm0X5xZQ_t3hHrLkGXmVj9LGVQdf0uEb_0R7mhxJtjSgPkubGbnW_fapM0XAEo2flUyBz4fLp_eeU8sDsxBfNiwzixfdPxlovo-XzRlG1Ez9QbIkISm2qjcD1jfHjaWPjlg5BPesu0NDOxMiri-zbZ_rxFZHH2f6m6G6NQeouGso_okW57Ru4h3FX52N1l0gRl0Mugpy16ce4KWdKplxbmS86MpCuVXSXWCg3cOxEeydARSwuxIOwni5FOHihD-tFRrE_sjbnmtkIlHludivaI9CWFfNGlBSXPjruQiU52njqS1RToKy7rGabLSsQ4g9nUHMfnw5CwsV_37SmaL_qY2UkNKj7P1-foFrnqDU_LZ_xC9DHueos0LwJMnsiOZbJwo0dy8LzWbHnQ3occeMsMyK22MYwiPEEZHpfIuehDcb041arvOCCs'

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

var _token = localStorage.getItem("_token") || undefined;
 //console.log(_token);

// 请求拦截
axios.interceptors.request.use(
  (config) => {
    if (_token) {
      if (
        config.method == "get" &&
        config.url.includes("https://restapi.amap.com")
      ) {
        delete config.params.notoken;
        if (config.headers.authorization) {
          delete config.headers.authorization;
        }
      } else {
        config.headers.authorization = _token;
      }
      // config.headers['auth-type'] = 'member';
      // config.headers['member-id'] = 11;
    }
    // config.headers['auth-type'] = 'member';
    // config.headers['member-id'] = 11;
    if (config.url === "/order/member/order/create") {
      let facility = "";
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        facility = "ios";
      } else if (/android/.test(ua)) {
        facility = "android";
      }
      config.headers.version = "2.3.5";
      config.headers.Charset = "UTF-8";
      config.headers.device = facility;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 0 || response.data.code === "SUCCESS") {
      return response.data.data;
    } else if (response.data.code === 12) {
      new Vue().params(null, null, "toLogin");
    } else if (response.data.code === 422) {
      console.log(response);
      console.error(`${response.data.code} --> ${response.data.messages}`);
      return Promise.reject(response.data.data);
    } else if (response.data.key) {
      //七牛云上传文件
      return response.data;
    } else if (response.data.code === 241202) {
      //携程酒店预订信息不可预订
      return response.data;
    } else if (response.data.code === "363") {
      //携程酒店预订信息入住人数需满足房间规定
      return Promise.reject(response.data);
    } else if (response.data.status == "1") {
      //高德定位转换
      return response.data;
    } else {
      console.log(response.data.code, "====>", response.data);
      return Promise.reject(response.data);
    }
  },
  (error) => {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      new Vue().params(null, null, "toLogin");
    }
    return Promise.reject(error);
  }
);

const http = {
  // 封装get请求
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 封装post请求
  post(url, data = {}, config) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setToken(token) {
    if (token) {
      _token = decodeURI(token);
      localStorage.setItem("_token", token);
    } else {
      _token = undefined;
      localStorage.removeItem("_token");
    }
    // 请求拦截
    axios.interceptors.request.use(
      (config) => {
        if (_token) {
          if (config.method == "get" && config.params.notoken) {
            delete config.params.notoken;
          } else {
            config.headers.authorization = _token;
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
  setuuid(uuid) {
    axios.interceptors.request.use(
      (config) => {
        if (uuid) {
          config.headers.uuid = uuid;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
};

export default http;
